import '/assets/styles/sections/app-nav.scss';
import { useMemo } from 'react';
import classNames from 'classnames';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Link from '@wearetla/tla-essentials-tools/partials/link';

// Context
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useBasket } from '/controllers/basket';

const AppNav = () => {
	const { selectedBranch, initialized } = useBranchSelection();
	const { openModal } = useModals();
	const { loggedIn, initialized: authInitialized } = useAuth();
	const { activeRoute } = useNavigator();
	const { itemCount } = useBasket();

	const [basketCountText, smallBasketCountText] = useMemo(
		() => (itemCount > 9 ? ['9+', true] : [itemCount, false]),
		[itemCount]
	);

	return (
		<nav className="section app-nav">
			<Link
				href="home"
				className={classNames('nav-btn', { active: activeRoute?.key?.startsWith?.('home') })}
				title="Menü"
			>
				<Icon className="btn-icon" name="home" />
			</Link>
			<Link navLink href="promotions" className="nav-btn" title="Promosyonlar">
				<Icon className="btn-icon" name="gift" />
			</Link>
			{selectedBranch ? (
				<Link href="menu" className="nav-orderbutton" title="Menüyü Gör">
					<Icon className="orderbutton-icon" name="menu" />
					<span>Menüyü Gör</span>
				</Link>
			) : (
				<>
					{initialized ? (
						<Link href="placeOrder" className="nav-orderbutton" title="Sipariş Ver">
							<Icon className="orderbutton-icon" name="qr" />
							<span>Sipariş Ver</span>
						</Link>
					) : (
						<span className="nav-orderbutton loading" title="Yükleniyor"></span>
					)}
				</>
			)}
			<Link navLink href="basket" className="nav-btn" title="Sepetim">
				{!!basketCountText && (
					<div className={classNames('btn-count', { small: smallBasketCountText })}>
						<span className="count-content">{basketCountText}</span>
					</div>
				)}
				<Icon className="btn-icon" name="cart" />
			</Link>
			{loggedIn ? (
				<Link navLink href="account" className="nav-btn" title="Hesabım">
					<Icon className="btn-icon" name="user" />
				</Link>
			) : (
				<button
					disabled={!authInitialized}
					type="button"
					className="nav-btn"
					onClick={() => {
						openModal('auth');
					}}
					title="Hesabım"
				>
					<Icon className="btn-icon" name="user" />
				</button>
			)}
		</nav>
	);
};

export default AppNav;
